function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-check-double",
  d: "M32.021 10.692l-2.51-2.422a1.555 1.555 0 00-2.149 0L12.177 22.917l-7.063-6.815a1.555 1.555 0 00-2.149 0L.447 18.526a1.433 1.433 0 000 2.079l10.651 10.28a1.555 1.555 0 002.149 0l18.768-18.114a1.438 1.438 0 00.006-2.079zM11.46 17.175a1.033 1.033 0 001.433 0L26.081 4.442a.957.957 0 000-1.382L23.215.289a1.033 1.033 0 00-1.433 0l-9.605 9.265L8.664 6.16a1.033 1.033 0 00-1.433 0L4.359 8.931a.957.957 0 000 1.382z",
  fill: "#ed6a5a"
});
var SvgDoubleCheckIcon = function SvgDoubleCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32.462 31.317"
  }, props), _ref);
};
export default SvgDoubleCheckIcon;